// Copyright 2021-2022 the Kubeapps contributors.
// SPDX-License-Identifier: Apache-2.0

/**
 * Dependencies for Remote Components
 */
module.exports = {
  resolve: {
    react: require("react"),
  },
};
